/* eslint-disable import/default, import/no-unresolved */
import React from "react";
import {render} from "react-dom";
import { validUrl } from "./utils/validator";
import App from "./components/App";
import "file?name=index.html!./index.html";
import "file?name=_redirects!./_redirects";
import "./styles/styles.scss"; // Yep, that's right. You can import SASS/CSS files too! Webpack will run the associated loader and plug this into the page.
require("./favicon.ico"); // Tell webpack to load favicon.ico

let [_, id, url] = document.location.pathname.split("/");
const isReport = id && !url;
let create = false;
if (!(id && !url)) {
  const m = (document.location.search || "").match(/q=([^&]+)/);
  if (m) {
    create = true;
    url = decodeURIComponent(m[1]);
  }
}

render(
  <App id={id} url={url} report={isReport} create={create} version="a" />, document.getElementById("app")
);



// WEBPACK FOOTER //
// ./src/index.js